import type { CheckoutVariant } from "@circle-react/components/Paywalls/Checkout/types/CheckoutVariant";

import { usePaywallCustomizationContext } from "../PaywallCustomizationProvider";
import { CountdownComponent } from "./CountdownComponent";
import { useCountdown } from "./hooks/useCountdown";
import { useCountdownPreview } from "./hooks/useCountdownPreview";

export interface CountdownProps {
  className?: string;
  variant?: CheckoutVariant;
}

export const Countdown = ({ className, variant = "main" }: CountdownProps) => {
  const { paywallCustomization, checkoutPreviewContext } =
    usePaywallCustomizationContext();

  const { enabled: isCountdownEnabled } =
    paywallCustomization?.countdown_properties || {
      enabled: false,
    };

  if (!paywallCustomization?.countdown_properties) {
    return null;
  }

  if (!isCountdownEnabled) {
    return null;
  }

  const countdownProperties = paywallCustomization.countdown_properties;
  if (checkoutPreviewContext) {
    return (
      <CountdownComponent
        className={className}
        countdownProperties={countdownProperties}
        useHook={useCountdownPreview}
        variant={variant}
      />
    );
  }

  return (
    <CountdownComponent
      className={className}
      countdownProperties={countdownProperties}
      useHook={useCountdown}
      variant={variant}
    />
  );
};
